import { Form, InputNumber, Switch } from "antd"
import styles from "./SwitchInput.module.css"
import { colors } from "themes/variables"
import { Text } from "ui/Typography"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import PropTypes from "prop-types"

export const SwitchInput = ({
  inputFormItemName,
  text,
  subText,
  infoText,
  checked,
  handleSwitchChange,
  hiddenSwitch,
  handleInputChange
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.typeWrapper}>
        {!hiddenSwitch && <Switch size="small" onChange={handleSwitchChange} checked={checked} />}
        <Text variant="body" size="md">
          {text}
        </Text>
        {subText && (
          <Text variant="body" size="md" color={colors.textSecondaryDark}>
            ({subText})
          </Text>
        )}
        {infoText && <InfoTooltip title={infoText} />}
      </div>
      {checked && (
        <Form.Item name={inputFormItemName} className="w-100">
          <InputNumber prefix="$" size="large" placeholder="100" min={0} defaultValue={0} className={styles.input} onChange={handleInputChange} type="number"
          />
        </Form.Item>
      )}
    </div>
  )
}

SwitchInput.propTypes = {
  inputFormItemName: PropTypes.string,
  text: PropTypes.string,
  subText: PropTypes.string,
  infoText: PropTypes.string,
  checked: PropTypes.bool,
  handleSwitchChange: PropTypes.func,
  hiddenSwitch: PropTypes.bool,
  handleInputChange: PropTypes.func,
}

